exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fengkong-default-page[data-v-6755b212]{min-height:200px}.version-switch-bar[data-v-6755b212]{position:sticky;top:0;z-index:20;background:rgba(255,255,255,.96);border-bottom:1px solid #e8eef8;-webkit-box-shadow:0 2px 8px rgba(75,119,215,.08);box-shadow:0 2px 8px rgba(75,119,215,.08)}.version-switch-inner[data-v-6755b212]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;gap:12px;padding:10px 24px;max-width:1920px;margin:0 auto}.version-switch-label[data-v-6755b212]{font-size:13px;color:#666}", ""]);

// exports
